import api from "@services/axios/apiManager";
import { useOrder } from "@utils/store/cart/useOrder";

/**
 * 把 bootstrap 該瓦斯行的營業狀態（is_open_now）與下一個營業時段（next_open_at）寫回 store。
 * 兩個一定一起寫：只更新 is_open_now 會讓 sessionStorage 留著舊的 next_open_at，
 * 休息提示就會叫客戶等一個已過去的時間。
 */
export function syncSupplierOpenState(target: { is_open_now?: boolean | null; next_open_at?: string | null }): void {
  const o = useOrder.getState();
  o.setIsOpenNow(target.is_open_now ?? true);
  o.setNextOpenAt(target.next_open_at ?? null);
}

/**
 * 送預約單被後端以「此時段已無法預約，請重新選擇」擋下後：
 * 1. 清掉目前選的時段（日期保留，時段選擇器會自行校正到仍可預約的日期）
 * 2. 重新抓 bootstrap，把該瓦斯行最新的 delivery_slots / is_open_now / next_open_at 寫回 store
 * Kiosk 與 GasShop 結帳共用。抓取失敗只記 log，不再另外提示（錯誤訊息已由送單 API 顯示）。
 */
export async function refreshDeliverySlots({
  jwtToken,
  xContext,
  supplierId,
}: {
  jwtToken: string;
  xContext: string;
  supplierId: string | null | undefined;
}): Promise<void> {
  const order = useOrder.getState();
  order.setDeliveryTime({ ...order.deliveryTime, slotId: null, slotSource: null, slotLabel: null });
  if (!supplierId) return;
  try {
    const res = await api.get("/app-api/platform-order-drafts/bootstrap", {
      headers: { Authorization: `Bearer ${jwtToken}`, "X-Context": xContext },
      params: { supplier_id: supplierId },
    });
    const target = (res?.data?.data?.available_suppliers || []).find((s: { supplier_id?: string }) => s.supplier_id === supplierId);
    if (!target) return;
    const o = useOrder.getState();
    if (target.delivery_slots) o.setDeliverySlots(target.delivery_slots);
    syncSupplierOpenState(target);
  } catch (e) {
    console.error("refresh delivery slots error", e);
  }
}
